const modalContants = {
    OPEN_LOGIN_MODAL: 'OPEN_LOGIN_MODAL',
    CLOSE_LOGIN_MODAL: 'CLOSE_LOGIN_MODAL',

    OPEN_TAB_MODAL: 'OPEN_TAB_MODAL',
    CLOSE_TAB_MODAL: 'CLOSE_TAB_MODAL',
}
export default modalContants
